export const countryflagCode = [
    {
      "countryName": "United States",
      "countryCode": "+1",
      "flagCode": "us",
      "flagUrl": "https://flagcdn.com/24x18/us.webp"
    },
    {
      "countryName": "United Kingdom",
      "countryCode": "+44",
      "flagCode": "gb",
      "flagUrl": "https://flagcdn.com/24x18/gb.webp"
    },
    {
      "countryName": "Afghanistan",
      "countryCode": "+93",
      "flagCode": "af",
      "flagUrl": "https://flagcdn.com/24x18/af.webp"
    },
    {
      "countryName": "Albania",
      "countryCode": "+355",
      "flagCode": "al",
      "flagUrl": "https://flagcdn.com/24x18/al.webp"
    },
    {
      "countryName": "Algeria",
      "countryCode": "+213",
      "flagCode": "dz",
      "flagUrl": "https://flagcdn.com/24x18/dz.webp"
    },
    {
      "countryName": "American Samoa",
      "countryCode": "+1",
      "flagCode": "as",
      "flagUrl": "https://flagcdn.com/24x18/as.webp"
    },
    {
      "countryName": "Andorra",
      "countryCode": "+376",
      "flagCode": "ad",
      "flagUrl": "https://flagcdn.com/24x18/ad.webp"
    },
    {
      "countryName": "Angola",
      "countryCode": "+244",
      "flagCode": "ao",
      "flagUrl": "https://flagcdn.com/24x18/ao.webp"
    },
    {
      "countryName": "Anguilla",
      "countryCode": "+1",
      "flagCode": "ai",
      "flagUrl": "https://flagcdn.com/24x18/ai.webp"
    },
    {
      "countryName": "Antigua & Barbuda",
      "countryCode": "+1",
      "flagCode": "ag",
      "flagUrl": "https://flagcdn.com/24x18/ag.webp"
    },
    {
      "countryName": "Argentina",
      "countryCode": "+54",
      "flagCode": "ar",
      "flagUrl": "https://flagcdn.com/24x18/ar.webp"
    },
    {
      "countryName": "Armenia",
      "countryCode": "+374",
      "flagCode": "am",
      "flagUrl": "https://flagcdn.com/24x18/am.webp"
    },
    {
      "countryName": "Aruba",
      "countryCode": "+297",
      "flagCode": "aw",
      "flagUrl": "https://flagcdn.com/24x18/aw.webp"
    },
    {
      "countryName": "Ascension Island",
      "countryCode": "+247",
      "flagCode": "ac",
      "flagUrl": "https://flagcdn.com/24x18/ac.webp"
    },
    {
      "countryName": "Australia",
      "countryCode": "+61",
      "flagCode": "au",
      "flagUrl": "https://flagcdn.com/24x18/au.webp"
    },
    {
      "countryName": "Austria",
      "countryCode": "+43",
      "flagCode": "at",
      "flagUrl": "https://flagcdn.com/24x18/at.webp"
    },
    {
      "countryName": "Azerbaijan",
      "countryCode": "+994",
      "flagCode": "az",
      "flagUrl": "https://flagcdn.com/24x18/az.webp"
    },
    {
      "countryName": "Bahamas",
      "countryCode": "+1",
      "flagCode": "bs",
      "flagUrl": "https://flagcdn.com/24x18/bs.webp"
    },
    {
      "countryName": "Bahrain",
      "countryCode": "+973",
      "flagCode": "bh",
      "flagUrl": "https://flagcdn.com/24x18/bh.webp"
    },
    {
      "countryName": "Bangladesh",
      "countryCode": "+880",
      "flagCode": "bd",
      "flagUrl": "https://flagcdn.com/24x18/bd.webp"
    },
    {
      "countryName": "Barbados",
      "countryCode": "+1",
      "flagCode": "bb",
      "flagUrl": "https://flagcdn.com/24x18/bb.webp"
    },
    {
      "countryName": "Belarus",
      "countryCode": "+375",
      "flagCode": "by",
      "flagUrl": "https://flagcdn.com/24x18/by.webp"
    },
    {
      "countryName": "Belgium",
      "countryCode": "+32",
      "flagCode": "be",
      "flagUrl": "https://flagcdn.com/24x18/be.webp"
    },
    {
      "countryName": "Belize",
      "countryCode": "+501",
      "flagCode": "bz",
      "flagUrl": "https://flagcdn.com/24x18/bz.webp"
    },
    {
      "countryName": "Benin",
      "countryCode": "+229",
      "flagCode": "bj",
      "flagUrl": "https://flagcdn.com/24x18/bj.webp"
    },
    {
      "countryName": "Bermuda",
      "countryCode": "+1",
      "flagCode": "bm",
      "flagUrl": "https://flagcdn.com/24x18/bm.webp"
    },
    {
      "countryName": "Bhutan",
      "countryCode": "+975",
      "flagCode": "bt",
      "flagUrl": "https://flagcdn.com/24x18/bt.webp"
    },
    {
      "countryName": "Bolivia",
      "countryCode": "+591",
      "flagCode": "bo",
      "flagUrl": "https://flagcdn.com/24x18/bo.webp"
    },
    {
      "countryName": "Bosnia & Herzegovina",
      "countryCode": "+387",
      "flagCode": "ba",
      "flagUrl": "https://flagcdn.com/24x18/ba.webp"
    },
    {
      "countryName": "Botswana",
      "countryCode": "+267",
      "flagCode": "bw",
      "flagUrl": "https://flagcdn.com/24x18/bw.webp"
    },
    {
      "countryName": "Brazil",
      "countryCode": "+55",
      "flagCode": "br",
      "flagUrl": "https://flagcdn.com/24x18/br.webp"
    },
    {
      "countryName": "British Indian Ocean Territory",
      "countryCode": "+246",
      "flagCode": "io",
      "flagUrl": "https://flagcdn.com/24x18/io.webp"
    },
    {
      "countryName": "British Virgin Islands",
      "countryCode": "+1",
      "flagCode": "vg",
      "flagUrl": "https://flagcdn.com/24x18/vg.webp"
    },
    {
      "countryName": "Brunei",
      "countryCode": "+673",
      "flagCode": "bn",
      "flagUrl": "https://flagcdn.com/24x18/bn.webp"
    },
    {
      "countryName": "Bulgaria",
      "countryCode": "+359",
      "flagCode": "bg",
      "flagUrl": "https://flagcdn.com/24x18/bg.webp"
    },
    {
      "countryName": "Burkina Faso",
      "countryCode": "+226",
      "flagCode": "bf",
      "flagUrl": "https://flagcdn.com/24x18/bf.webp"
    },
    {
      "countryName": "Burundi",
      "countryCode": "+257",
      "flagCode": "bi",
      "flagUrl": "https://flagcdn.com/24x18/bi.webp"
    },
    {
      "countryName": "Cambodia",
      "countryCode": "+855",
      "flagCode": "kh",
      "flagUrl": "https://flagcdn.com/24x18/kh.webp"
    },
    {
      "countryName": "Cameroon",
      "countryCode": "+237",
      "flagCode": "cm",
      "flagUrl": "https://flagcdn.com/24x18/cm.webp"
    },
    {
      "countryName": "Canada",
      "countryCode": "+1",
      "flagCode": "ca",
      "flagUrl": "https://flagcdn.com/24x18/ca.webp"
    },
    {
      "countryName": "Cape Verde",
      "countryCode": "+238",
      "flagCode": "cv",
      "flagUrl": "https://flagcdn.com/24x18/cv.webp"
    },
    {
      "countryName": "Caribbean Netherlands",
      "countryCode": "+599",
      "flagCode": "bq",
      "flagUrl": "https://flagcdn.com/24x18/bq.webp"
    },
    {
      "countryName": "Cayman Islands",
      "countryCode": "+1",
      "flagCode": "ky",
      "flagUrl": "https://flagcdn.com/24x18/ky.webp"
    },
    {
      "countryName": "Central African Republic",
      "countryCode": "+236",
      "flagCode": "cf",
      "flagUrl": "https://flagcdn.com/24x18/cf.webp"
    },
    {
      "countryName": "Chad",
      "countryCode": "+235",
      "flagCode": "td",
      "flagUrl": "https://flagcdn.com/24x18/td.webp"
    },
    {
      "countryName": "Chile",
      "countryCode": "+56",
      "flagCode": "cl",
      "flagUrl": "https://flagcdn.com/24x18/cl.webp"
    },
    {
      "countryName": "China",
      "countryCode": "+86",
      "flagCode": "cn",
      "flagUrl": "https://flagcdn.com/24x18/cn.webp"
    },
    {
      "countryName": "Christmas Island",
      "countryCode": "+61",
      "flagCode": "cx",
      "flagUrl": "https://flagcdn.com/24x18/cx.webp"
    },
    {
      "countryName": "Cocos (Keeling) Islands",
      "countryCode": "+61",
      "flagCode": "cc",
      "flagUrl": "https://flagcdn.com/24x18/cc.webp"
    },
    {
      "countryName": "Colombia",
      "countryCode": "+57",
      "flagCode": "co",
      "flagUrl": "https://flagcdn.com/24x18/co.webp"
    },
    {
      "countryName": "Comoros",
      "countryCode": "+269",
      "flagCode": "km",
      "flagUrl": "https://flagcdn.com/24x18/km.webp"
    },
    {
      "countryName": "Congo - Brazzaville",
      "countryCode": "+242",
      "flagCode": "cg",
      "flagUrl": "https://flagcdn.com/24x18/cg.webp"
    },
    {
      "countryName": "Congo - Kinshasa",
      "countryCode": "+243",
      "flagCode": "cd",
      "flagUrl": "https://flagcdn.com/24x18/cd.webp"
    },
    {
      "countryName": "Cook Islands",
      "countryCode": "+682",
      "flagCode": "ck",
      "flagUrl": "https://flagcdn.com/24x18/ck.webp"
    },
    {
      "countryName": "Costa Rica",
      "countryCode": "+506",
      "flagCode": "cr",
      "flagUrl": "https://flagcdn.com/24x18/cr.webp"
    },
    {
      "countryName": "Côte d’Ivoire",
      "countryCode": "+225",
      "flagCode": "ci",
      "flagUrl": "https://flagcdn.com/24x18/ci.webp"
    },
    {
      "countryName": "Croatia",
      "countryCode": "+385",
      "flagCode": "hr",
      "flagUrl": "https://flagcdn.com/24x18/hr.webp"
    },
    {
      "countryName": "Cuba",
      "countryCode": "+53",
      "flagCode": "cu",
      "flagUrl": "https://flagcdn.com/24x18/cu.webp"
    },
    {
      "countryName": "Curaçao",
      "countryCode": "+599",
      "flagCode": "cw",
      "flagUrl": "https://flagcdn.com/24x18/cw.webp"
    },
    {
      "countryName": "Cyprus",
      "countryCode": "+357",
      "flagCode": "cy",
      "flagUrl": "https://flagcdn.com/24x18/cy.webp"
    },
    {
      "countryName": "Czech Republic",
      "countryCode": "+420",
      "flagCode": "cz",
      "flagUrl": "https://flagcdn.com/24x18/cz.webp"
    },
    {
      "countryName": "Denmark",
      "countryCode": "+45",
      "flagCode": "dk",
      "flagUrl": "https://flagcdn.com/24x18/dk.webp"
    },
    {
      "countryName": "Djibouti",
      "countryCode": "+253",
      "flagCode": "dj",
      "flagUrl": "https://flagcdn.com/24x18/dj.webp"
    },
    {
      "countryName": "Dominica",
      "countryCode": "+1",
      "flagCode": "dm",
      "flagUrl": "https://flagcdn.com/24x18/dm.webp"
    },
    {
      "countryName": "Dominican Republic",
      "countryCode": "+1",
      "flagCode": "do",
      "flagUrl": "https://flagcdn.com/24x18/do.webp"
    },
    {
      "countryName": "Ecuador",
      "countryCode": "+593",
      "flagCode": "ec",
      "flagUrl": "https://flagcdn.com/24x18/ec.webp"
    },
    {
      "countryName": "Egypt",
      "countryCode": "+20",
      "flagCode": "eg",
      "flagUrl": "https://flagcdn.com/24x18/eg.webp"
    },
    {
      "countryName": "El Salvador",
      "countryCode": "+503",
      "flagCode": "sv",
      "flagUrl": "https://flagcdn.com/24x18/sv.webp"
    },
    {
      "countryName": "Equatorial Guinea",
      "countryCode": "+240",
      "flagCode": "gq",
      "flagUrl": "https://flagcdn.com/24x18/gq.webp"
    },
    {
      "countryName": "Eritrea",
      "countryCode": "+291",
      "flagCode": "er",
      "flagUrl": "https://flagcdn.com/24x18/er.webp"
    },
    {
      "countryName": "Estonia",
      "countryCode": "+372",
      "flagCode": "ee",
      "flagUrl": "https://flagcdn.com/24x18/ee.webp"
    },
    {
      "countryName": "Eswatini",
      "countryCode": "+268",
      "flagCode": "sz",
      "flagUrl": "https://flagcdn.com/24x18/sz.webp"
    },
    {
      "countryName": "Ethiopia",
      "countryCode": "+251",
      "flagCode": "et",
      "flagUrl": "https://flagcdn.com/24x18/et.webp"
    },
    {
      "countryName": "Falkland Islands",
      "countryCode": "+500",
      "flagCode": "fk",
      "flagUrl": "https://flagcdn.com/24x18/fk.webp"
    },
    {
      "countryName": "Faroe Islands",
      "countryCode": "+298",
      "flagCode": "fo",
      "flagUrl": "https://flagcdn.com/24x18/fo.webp"
    },
    {
      "countryName": "Fiji",
      "countryCode": "+679",
      "flagCode": "fj",
      "flagUrl": "https://flagcdn.com/24x18/fj.webp"
    },
    {
      "countryName": "Finland",
      "countryCode": "+358",
      "flagCode": "fi",
      "flagUrl": "https://flagcdn.com/24x18/fi.webp"
    },
    {
      "countryName": "France",
      "countryCode": "+33",
      "flagCode": "fr",
      "flagUrl": "https://flagcdn.com/24x18/fr.webp"
    },
    {
      "countryName": "French Guiana",
      "countryCode": "+594",
      "flagCode": "gf",
      "flagUrl": "https://flagcdn.com/24x18/gf.webp"
    },
    {
      "countryName": "French Polynesia",
      "countryCode": "+689",
      "flagCode": "pf",
      "flagUrl": "https://flagcdn.com/24x18/pf.webp"
    },
    {
      "countryName": "Gabon",
      "countryCode": "+241",
      "flagCode": "ga",
      "flagUrl": "https://flagcdn.com/24x18/ga.webp"
    },
    {
      "countryName": "Gambia",
      "countryCode": "+220",
      "flagCode": "gm",
      "flagUrl": "https://flagcdn.com/24x18/gm.webp"
    },
    {
      "countryName": "Georgia",
      "countryCode": "+995",
      "flagCode": "ge",
      "flagUrl": "https://flagcdn.com/24x18/ge.webp"
    },
    {
      "countryName": "Germany",
      "countryCode": "+49",
      "flagCode": "de",
      "flagUrl": "https://flagcdn.com/24x18/de.webp"
    },
    {
      "countryName": "Ghana",
      "countryCode": "+233",
      "flagCode": "gh",
      "flagUrl": "https://flagcdn.com/24x18/gh.webp"
    },
    {
      "countryName": "Gibraltar",
      "countryCode": "+350",
      "flagCode": "gi",
      "flagUrl": "https://flagcdn.com/24x18/gi.webp"
    },
    {
      "countryName": "Greece",
      "countryCode": "+30",
      "flagCode": "gr",
      "flagUrl": "https://flagcdn.com/24x18/gr.webp"
    },
    {
      "countryName": "Greenland",
      "countryCode": "+299",
      "flagCode": "gl",
      "flagUrl": "https://flagcdn.com/24x18/gl.webp"
    },
    {
      "countryName": "Grenada",
      "countryCode": "+1",
      "flagCode": "gd",
      "flagUrl": "https://flagcdn.com/24x18/gd.webp"
    },
    {
      "countryName": "Guadeloupe",
      "countryCode": "+590",
      "flagCode": "gp",
      "flagUrl": "https://flagcdn.com/24x18/gp.webp"
    },
    {
      "countryName": "Guam",
      "countryCode": "+1",
      "flagCode": "gu",
      "flagUrl": "https://flagcdn.com/24x18/gu.webp"
    },
    {
      "countryName": "Guatemala",
      "countryCode": "+502",
      "flagCode": "gt",
      "flagUrl": "https://flagcdn.com/24x18/gt.webp"
    },
    {
      "countryName": "Guernsey",
      "countryCode": "+44",
      "flagCode": "gg",
      "flagUrl": "https://flagcdn.com/24x18/gg.webp"
    },
    {
      "countryName": "Guinea",
      "countryCode": "+224",
      "flagCode": "gn",
      "flagUrl": "https://flagcdn.com/24x18/gn.webp"
    },
    {
      "countryName": "Guinea-Bissau",
      "countryCode": "+245",
      "flagCode": "gw",
      "flagUrl": "https://flagcdn.com/24x18/gw.webp"
    },
    {
      "countryName": "Guyana",
      "countryCode": "+592",
      "flagCode": "gy",
      "flagUrl": "https://flagcdn.com/24x18/gy.webp"
    },
    {
      "countryName": "Haiti",
      "countryCode": "+509",
      "flagCode": "ht",
      "flagUrl": "https://flagcdn.com/24x18/ht.webp"
    },
    {
      "countryName": "Honduras",
      "countryCode": "+504",
      "flagCode": "hn",
      "flagUrl": "https://flagcdn.com/24x18/hn.webp"
    },
    {
      "countryName": "Hong Kong",
      "countryCode": "+852",
      "flagCode": "hk",
      "flagUrl": "https://flagcdn.com/24x18/hk.webp"
    },
    {
      "countryName": "Hungary",
      "countryCode": "+36",
      "flagCode": "hu",
      "flagUrl": "https://flagcdn.com/24x18/hu.webp"
    },
    {
      "countryName": "Iceland",
      "countryCode": "+354",
      "flagCode": "is",
      "flagUrl": "https://flagcdn.com/24x18/is.webp"
    },
    {
      "countryName": "India",
      "countryCode": "+91",
      "flagCode": "in",
      "flagUrl": "https://flagcdn.com/24x18/in.webp"
    },
    {
      "countryName": "Indonesia",
      "countryCode": "+62",
      "flagCode": "id",
      "flagUrl": "https://flagcdn.com/24x18/id.webp"
    },
    {
      "countryName": "Iran",
      "countryCode": "+98",
      "flagCode": "ir",
      "flagUrl": "https://flagcdn.com/24x18/ir.webp"
    },
    {
      "countryName": "Iraq",
      "countryCode": "+964",
      "flagCode": "iq",
      "flagUrl": "https://flagcdn.com/24x18/iq.webp"
    },
    {
      "countryName": "Ireland",
      "countryCode": "+353",
      "flagCode": "ie",
      "flagUrl": "https://flagcdn.com/24x18/ie.webp"
    },
    {
      "countryName": "Isle of Man",
      "countryCode": "+44",
      "flagCode": "im",
      "flagUrl": "https://flagcdn.com/24x18/im.webp"
    },
    {
      "countryName": "Israel",
      "countryCode": "+972",
      "flagCode": "il",
      "flagUrl": "https://flagcdn.com/24x18/il.webp"
    },
    {
      "countryName": "Italy",
      "countryCode": "+39",
      "flagCode": "it",
      "flagUrl": "https://flagcdn.com/24x18/it.webp"
    },
    {
      "countryName": "Jamaica",
      "countryCode": "+1",
      "flagCode": "jm",
      "flagUrl": "https://flagcdn.com/24x18/jm.webp"
    },
    {
      "countryName": "Japan",
      "countryCode": "+81",
      "flagCode": "jp",
      "flagUrl": "https://flagcdn.com/24x18/jp.webp"
    },
    {
      "countryName": "Jersey",
      "countryCode": "+44",
      "flagCode": "je",
      "flagUrl": "https://flagcdn.com/24x18/je.webp"
    },
    {
      "countryName": "Jordan",
      "countryCode": "+962",
      "flagCode": "jo",
      "flagUrl": "https://flagcdn.com/24x18/jo.webp"
    },
    {
      "countryName": "Kazakhstan",
      "countryCode": "+7",
      "flagCode": "kz",
      "flagUrl": "https://flagcdn.com/24x18/kz.webp"
    },
    {
      "countryName": "Kenya",
      "countryCode": "+254",
      "flagCode": "ke",
      "flagUrl": "https://flagcdn.com/24x18/ke.webp"
    },
    {
      "countryName": "Kiribati",
      "countryCode": "+686",
      "flagCode": "ki",
      "flagUrl": "https://flagcdn.com/24x18/ki.webp"
    },
    {
      "countryName": "Kosovo",
      "countryCode": "+383",
      "flagCode": "xk",
      "flagUrl": "https://flagcdn.com/24x18/xk.webp"
    },
    {
      "countryName": "Kuwait",
      "countryCode": "+965",
      "flagCode": "kw",
      "flagUrl": "https://flagcdn.com/24x18/kw.webp"
    },
    {
      "countryName": "Kyrgyzstan",
      "countryCode": "+996",
      "flagCode": "kg",
      "flagUrl": "https://flagcdn.com/24x18/kg.webp"
    },
    {
      "countryName": "Laos",
      "countryCode": "+856",
      "flagCode": "la",
      "flagUrl": "https://flagcdn.com/24x18/la.webp"
    },
    {
      "countryName": "Latvia",
      "countryCode": "+371",
      "flagCode": "lv",
      "flagUrl": "https://flagcdn.com/24x18/lv.webp"
    },
    {
      "countryName": "Lebanon",
      "countryCode": "+961",
      "flagCode": "lb",
      "flagUrl": "https://flagcdn.com/24x18/lb.webp"
    },
    {
      "countryName": "Lesotho",
      "countryCode": "+266",
      "flagCode": "ls",
      "flagUrl": "https://flagcdn.com/24x18/ls.webp"
    },
    {
      "countryName": "Liberia",
      "countryCode": "+231",
      "flagCode": "lr",
      "flagUrl": "https://flagcdn.com/24x18/lr.webp"
    },
    {
      "countryName": "Libya",
      "countryCode": "+218",
      "flagCode": "ly",
      "flagUrl": "https://flagcdn.com/24x18/ly.webp"
    },
    {
      "countryName": "Liechtenstein",
      "countryCode": "+423",
      "flagCode": "li",
      "flagUrl": "https://flagcdn.com/24x18/li.webp"
    },
    {
      "countryName": "Lithuania",
      "countryCode": "+370",
      "flagCode": "lt",
      "flagUrl": "https://flagcdn.com/24x18/lt.webp"
    },
    {
      "countryName": "Luxembourg",
      "countryCode": "+352",
      "flagCode": "lu",
      "flagUrl": "https://flagcdn.com/24x18/lu.webp"
    },
    {
      "countryName": "Macau",
      "countryCode": "+853",
      "flagCode": "mo",
      "flagUrl": "https://flagcdn.com/24x18/mo.webp"
    },
    {
      "countryName": "Madagascar",
      "countryCode": "+261",
      "flagCode": "mg",
      "flagUrl": "https://flagcdn.com/24x18/mg.webp"
    },
    {
      "countryName": "Malawi",
      "countryCode": "+265",
      "flagCode": "mw",
      "flagUrl": "https://flagcdn.com/24x18/mw.webp"
    },
    {
      "countryName": "Malaysia",
      "countryCode": "+60",
      "flagCode": "my",
      "flagUrl": "https://flagcdn.com/24x18/my.webp"
    },
    {
      "countryName": "Maldives",
      "countryCode": "+960",
      "flagCode": "mv",
      "flagUrl": "https://flagcdn.com/24x18/mv.webp"
    },
    {
      "countryName": "Mali",
      "countryCode": "+223",
      "flagCode": "ml",
      "flagUrl": "https://flagcdn.com/24x18/ml.webp"
    },
    {
      "countryName": "Malta",
      "countryCode": "+356",
      "flagCode": "mt",
      "flagUrl": "https://flagcdn.com/24x18/mt.webp"
    },
    {
      "countryName": "Marshall Islands",
      "countryCode": "+692",
      "flagCode": "mh",
      "flagUrl": "https://flagcdn.com/24x18/mh.webp"
    },
    {
      "countryName": "Martinique",
      "countryCode": "+596",
      "flagCode": "mq",
      "flagUrl": "https://flagcdn.com/24x18/mq.webp"
    },
    {
      "countryName": "Mauritania",
      "countryCode": "+222",
      "flagCode": "mr",
      "flagUrl": "https://flagcdn.com/24x18/mr.webp"
    },
    {
      "countryName": "Mauritius",
      "countryCode": "+230",
      "flagCode": "mu",
      "flagUrl": "https://flagcdn.com/24x18/mu.webp"
    },
    {
      "countryName": "Mayotte",
      "countryCode": "+262",
      "flagCode": "yt",
      "flagUrl": "https://flagcdn.com/24x18/yt.webp"
    },
    {
      "countryName": "Mexico",
      "countryCode": "+52",
      "flagCode": "mx",
      "flagUrl": "https://flagcdn.com/24x18/mx.webp"
    },
    {
      "countryName": "Micronesia",
      "countryCode": "+691",
      "flagCode": "fm",
      "flagUrl": "https://flagcdn.com/24x18/fm.webp"
    },
    {
      "countryName": "Moldova",
      "countryCode": "+373",
      "flagCode": "md",
      "flagUrl": "https://flagcdn.com/24x18/md.webp"
    },
    {
      "countryName": "Monaco",
      "countryCode": "+377",
      "flagCode": "mc",
      "flagUrl": "https://flagcdn.com/24x18/mc.webp"
    },
    {
      "countryName": "Mongolia",
      "countryCode": "+976",
      "flagCode": "mn",
      "flagUrl": "https://flagcdn.com/24x18/mn.webp"
    },
    {
      "countryName": "Montenegro",
      "countryCode": "+382",
      "flagCode": "me",
      "flagUrl": "https://flagcdn.com/24x18/me.webp"
    },
    {
      "countryName": "Montserrat",
      "countryCode": "+1",
      "flagCode": "ms",
      "flagUrl": "https://flagcdn.com/24x18/ms.webp"
    },
    {
      "countryName": "Morocco",
      "countryCode": "+212",
      "flagCode": "ma",
      "flagUrl": "https://flagcdn.com/24x18/ma.webp"
    },
    {
      "countryName": "Mozambique",
      "countryCode": "+258",
      "flagCode": "mz",
      "flagUrl": "https://flagcdn.com/24x18/mz.webp"
    },
    {
      "countryName": "Myanmar (Burma)",
      "countryCode": "+95",
      "flagCode": "mm",
      "flagUrl": "https://flagcdn.com/24x18/mm.webp"
    },
    {
      "countryName": "Namibia",
      "countryCode": "+264",
      "flagCode": "na",
      "flagUrl": "https://flagcdn.com/24x18/na.webp"
    },
    {
      "countryName": "Nauru",
      "countryCode": "+674",
      "flagCode": "nr",
      "flagUrl": "https://flagcdn.com/24x18/nr.webp"
    },
    {
      "countryName": "Nepal",
      "countryCode": "+977",
      "flagCode": "np",
      "flagUrl": "https://flagcdn.com/24x18/np.webp"
    },
    {
      "countryName": "Netherlands",
      "countryCode": "+31",
      "flagCode": "nl",
      "flagUrl": "https://flagcdn.com/24x18/nl.webp"
    },
    {
      "countryName": "New Caledonia",
      "countryCode": "+687",
      "flagCode": "nc",
      "flagUrl": "https://flagcdn.com/24x18/nc.webp"
    },
    {
      "countryName": "New Zealand",
      "countryCode": "+64",
      "flagCode": "nz",
      "flagUrl": "https://flagcdn.com/24x18/nz.webp"
    },
    {
      "countryName": "Nicaragua",
      "countryCode": "+505",
      "flagCode": "ni",
      "flagUrl": "https://flagcdn.com/24x18/ni.webp"
    },
    {
      "countryName": "Niger",
      "countryCode": "+227",
      "flagCode": "ne",
      "flagUrl": "https://flagcdn.com/24x18/ne.webp"
    },
    {
      "countryName": "Nigeria",
      "countryCode": "+234",
      "flagCode": "ng",
      "flagUrl": "https://flagcdn.com/24x18/ng.webp"
    },
    {
      "countryName": "Niue",
      "countryCode": "+683",
      "flagCode": "nu",
      "flagUrl": "https://flagcdn.com/24x18/nu.webp"
    },
    {
      "countryName": "Norfolk Island",
      "countryCode": "+672",
      "flagCode": "nf",
      "flagUrl": "https://flagcdn.com/24x18/nf.webp"
    },
    {
      "countryName": "North Korea",
      "countryCode": "+850",
      "flagCode": "kp",
      "flagUrl": "https://flagcdn.com/24x18/kp.webp"
    },
    {
      "countryName": "North Macedonia",
      "countryCode": "+389",
      "flagCode": "mk",
      "flagUrl": "https://flagcdn.com/24x18/mk.webp"
    },
    {
      "countryName": "Northern Mariana Islands",
      "countryCode": "+1",
      "flagCode": "mp",
      "flagUrl": "https://flagcdn.com/24x18/mp.webp"
    },
    {
      "countryName": "Norway",
      "countryCode": "+47",
      "flagCode": "no",
      "flagUrl": "https://flagcdn.com/24x18/no.webp"
    },
    {
      "countryName": "Oman",
      "countryCode": "+968",
      "flagCode": "om",
      "flagUrl": "https://flagcdn.com/24x18/om.webp"
    },
    {
      "countryName": "Pakistan",
      "countryCode": "+92",
      "flagCode": "pk",
      "flagUrl": "https://flagcdn.com/24x18/pk.webp"
    },
    {
      "countryName": "Palau",
      "countryCode": "+680",
      "flagCode": "pw",
      "flagUrl": "https://flagcdn.com/24x18/pw.webp"
    },
    {
      "countryName": "Palestine",
      "countryCode": "+970",
      "flagCode": "ps",
      "flagUrl": "https://flagcdn.com/24x18/ps.webp"
    },
    {
      "countryName": "Panama",
      "countryCode": "+507",
      "flagCode": "pa",
      "flagUrl": "https://flagcdn.com/24x18/pa.webp"
    },
    {
      "countryName": "Papua New Guinea",
      "countryCode": "+675",
      "flagCode": "pg",
      "flagUrl": "https://flagcdn.com/24x18/pg.webp"
    },
    {
      "countryName": "Paraguay",
      "countryCode": "+595",
      "flagCode": "py",
      "flagUrl": "https://flagcdn.com/24x18/py.webp"
    },
    {
      "countryName": "Peru",
      "countryCode": "+51",
      "flagCode": "pe",
      "flagUrl": "https://flagcdn.com/24x18/pe.webp"
    },
    {
      "countryName": "Philippines",
      "countryCode": "+63",
      "flagCode": "ph",
      "flagUrl": "https://flagcdn.com/24x18/ph.webp"
    },
    {
      "countryName": "Poland",
      "countryCode": "+48",
      "flagCode": "pl",
      "flagUrl": "https://flagcdn.com/24x18/pl.webp"
    },
    {
      "countryName": "Portugal",
      "countryCode": "+351",
      "flagCode": "pt",
      "flagUrl": "https://flagcdn.com/24x18/pt.webp"
    },
    {
      "countryName": "Puerto Rico",
      "countryCode": "+1",
      "flagCode": "pr",
      "flagUrl": "https://flagcdn.com/24x18/pr.webp"
    },
    {
      "countryName": "Qatar",
      "countryCode": "+974",
      "flagCode": "qa",
      "flagUrl": "https://flagcdn.com/24x18/qa.webp"
    },
    {
      "countryName": "Réunion",
      "countryCode": "+262",
      "flagCode": "re",
      "flagUrl": "https://flagcdn.com/24x18/re.webp"
    },
    {
      "countryName": "Romania",
      "countryCode": "+40",
      "flagCode": "ro",
      "flagUrl": "https://flagcdn.com/24x18/ro.webp"
    },
    {
      "countryName": "Russia",
      "countryCode": "+7",
      "flagCode": "ru",
      "flagUrl": "https://flagcdn.com/24x18/ru.webp"
    },
    {
      "countryName": "Rwanda",
      "countryCode": "+250",
      "flagCode": "rw",
      "flagUrl": "https://flagcdn.com/24x18/rw.webp"
    },
    {
      "countryName": "Samoa",
      "countryCode": "+685",
      "flagCode": "ws",
      "flagUrl": "https://flagcdn.com/24x18/ws.webp"
    },
    {
      "countryName": "San Marino",
      "countryCode": "+378",
      "flagCode": "sm",
      "flagUrl": "https://flagcdn.com/24x18/sm.webp"
    },
    {
      "countryName": "São Tomé & Príncipe",
      "countryCode": "+239",
      "flagCode": "st",
      "flagUrl": "https://flagcdn.com/24x18/st.webp"
    },
    {
      "countryName": "Saudi Arabia",
      "countryCode": "+966",
      "flagCode": "sa",
      "flagUrl": "https://flagcdn.com/24x18/sa.webp"
    },
    {
      "countryName": "Senegal",
      "countryCode": "+221",
      "flagCode": "sn",
      "flagUrl": "https://flagcdn.com/24x18/sn.webp"
    },
    {
      "countryName": "Serbia",
      "countryCode": "+381",
      "flagCode": "rs",
      "flagUrl": "https://flagcdn.com/24x18/rs.webp"
    },
    {
      "countryName": "Seychelles",
      "countryCode": "+248",
      "flagCode": "sc",
      "flagUrl": "https://flagcdn.com/24x18/sc.webp"
    },
    {
      "countryName": "Sierra Leone",
      "countryCode": "+232",
      "flagCode": "sl",
      "flagUrl": "https://flagcdn.com/24x18/sl.webp"
    },
    {
      "countryName": "Singapore",
      "countryCode": "+65",
      "flagCode": "sg",
      "flagUrl": "https://flagcdn.com/24x18/sg.webp"
    },
    {
      "countryName": "Sint Maarten",
      "countryCode": "+1",
      "flagCode": "sx",
      "flagUrl": "https://flagcdn.com/24x18/sx.webp"
    },
    {
      "countryName": "Slovakia",
      "countryCode": "+421",
      "flagCode": "sk",
      "flagUrl": "https://flagcdn.com/24x18/sk.webp"
    },
    {
      "countryName": "Slovenia",
      "countryCode": "+386",
      "flagCode": "si",
      "flagUrl": "https://flagcdn.com/24x18/si.webp"
    },
    {
      "countryName": "Solomon Islands",
      "countryCode": "+677",
      "flagCode": "sb",
      "flagUrl": "https://flagcdn.com/24x18/sb.webp"
    },
    {
      "countryName": "Somalia",
      "countryCode": "+252",
      "flagCode": "so",
      "flagUrl": "https://flagcdn.com/24x18/so.webp"
    },
    {
      "countryName": "South Africa",
      "countryCode": "+27",
      "flagCode": "za",
      "flagUrl": "https://flagcdn.com/24x18/za.webp"
    },
    {
      "countryName": "South Korea",
      "countryCode": "+82",
      "flagCode": "kr",
      "flagUrl": "https://flagcdn.com/24x18/kr.webp"
    },
    {
      "countryName": "South Sudan",
      "countryCode": "+211",
      "flagCode": "ss",
      "flagUrl": "https://flagcdn.com/24x18/ss.webp"
    },
    {
      "countryName": "Spain",
      "countryCode": "+34",
      "flagCode": "es",
      "flagUrl": "https://flagcdn.com/24x18/es.webp"
    },
    {
      "countryName": "Sri Lanka",
      "countryCode": "+94",
      "flagCode": "lk",
      "flagUrl": "https://flagcdn.com/24x18/lk.webp"
    },
    {
      "countryName": "St Barthélemy",
      "countryCode": "+590",
      "flagCode": "bl",
      "flagUrl": "https://flagcdn.com/24x18/bl.webp"
    },
    {
      "countryName": "St Helena",
      "countryCode": "+290",
      "flagCode": "sh",
      "flagUrl": "https://flagcdn.com/24x18/sh.webp"
    },
    {
      "countryName": "St Kitts & Nevis",
      "countryCode": "+1",
      "flagCode": "kn",
      "flagUrl": "https://flagcdn.com/24x18/kn.webp"
    },
    {
      "countryName": "St Lucia",
      "countryCode": "+1",
      "flagCode": "lc",
      "flagUrl": "https://flagcdn.com/24x18/lc.webp"
    },
    {
      "countryName": "St Martin",
      "countryCode": "+590",
      "flagCode": "mf",
      "flagUrl": "https://flagcdn.com/24x18/mf.webp"
    },
    {
      "countryName": "St Pierre & Miquelon",
      "countryCode": "+508",
      "flagCode": "pm",
      "flagUrl": "https://flagcdn.com/24x18/pm.webp"
    },
    {
      "countryName": "St Vincent & Grenadines",
      "countryCode": "+1",
      "flagCode": "vc",
      "flagUrl": "https://flagcdn.com/24x18/vc.webp"
    },
    {
      "countryName": "Sudan",
      "countryCode": "+249",
      "flagCode": "sd",
      "flagUrl": "https://flagcdn.com/24x18/sd.webp"
    },
    {
      "countryName": "Suriname",
      "countryCode": "+597",
      "flagCode": "sr",
      "flagUrl": "https://flagcdn.com/24x18/sr.webp"
    },
    {
      "countryName": "Svalbard & Jan Mayen",
      "countryCode": "+47",
      "flagCode": "sj",
      "flagUrl": "https://flagcdn.com/24x18/sj.webp"
    },
    {
      "countryName": "Sweden",
      "countryCode": "+46",
      "flagCode": "se",
      "flagUrl": "https://flagcdn.com/24x18/se.webp"
    },
    {
      "countryName": "Switzerland",
      "countryCode": "+41",
      "flagCode": "ch",
      "flagUrl": "https://flagcdn.com/24x18/ch.webp"
    },
    {
      "countryName": "Syria",
      "countryCode": "+963",
      "flagCode": "sy",
      "flagUrl": "https://flagcdn.com/24x18/sy.webp"
    },
    {
      "countryName": "Taiwan",
      "countryCode": "+886",
      "flagCode": "tw",
      "flagUrl": "https://flagcdn.com/24x18/tw.webp"
    },
    {
      "countryName": "Tajikistan",
      "countryCode": "+992",
      "flagCode": "tj",
      "flagUrl": "https://flagcdn.com/24x18/tj.webp"
    },
    {
      "countryName": "Tanzania",
      "countryCode": "+255",
      "flagCode": "tz",
      "flagUrl": "https://flagcdn.com/24x18/tz.webp"
    },
    {
      "countryName": "Thailand",
      "countryCode": "+66",
      "flagCode": "th",
      "flagUrl": "https://flagcdn.com/24x18/th.webp"
    },
    {
      "countryName": "Timor-Leste",
      "countryCode": "+670",
      "flagCode": "tl",
      "flagUrl": "https://flagcdn.com/24x18/tl.webp"
    },
    {
      "countryName": "Togo",
      "countryCode": "+228",
      "flagCode": "tg",
      "flagUrl": "https://flagcdn.com/24x18/tg.webp"
    },
    {
      "countryName": "Tokelau",
      "countryCode": "+690",
      "flagCode": "tk",
      "flagUrl": "https://flagcdn.com/24x18/tk.webp"
    },
    {
      "countryName": "Tonga",
      "countryCode": "+676",
      "flagCode": "to",
      "flagUrl": "https://flagcdn.com/24x18/to.webp"
    },
    {
      "countryName": "Trinidad & Tobago",
      "countryCode": "+1",
      "flagCode": "tt",
      "flagUrl": "https://flagcdn.com/24x18/tt.webp"
    },
    {
      "countryName": "Tunisia",
      "countryCode": "+216",
      "flagCode": "tn",
      "flagUrl": "https://flagcdn.com/24x18/tn.webp"
    },
    {
      "countryName": "Turkey",
      "countryCode": "+90",
      "flagCode": "tr",
      "flagUrl": "https://flagcdn.com/24x18/tr.webp"
    },
    {
      "countryName": "Turkmenistan",
      "countryCode": "+993",
      "flagCode": "tm",
      "flagUrl": "https://flagcdn.com/24x18/tm.webp"
    },
    {
      "countryName": "Turks & Caicos Islands",
      "countryCode": "+1",
      "flagCode": "tc",
      "flagUrl": "https://flagcdn.com/24x18/tc.webp"
    },
    {
      "countryName": "Tuvalu",
      "countryCode": "+688",
      "flagCode": "tv",
      "flagUrl": "https://flagcdn.com/24x18/tv.webp"
    },
    {
      "countryName": "Uganda",
      "countryCode": "+256",
      "flagCode": "ug",
      "flagUrl": "https://flagcdn.com/24x18/ug.webp"
    },
    {
      "countryName": "Ukraine",
      "countryCode": "+380",
      "flagCode": "ua",
      "flagUrl": "https://flagcdn.com/24x18/ua.webp"
    },
    {
      "countryName": "United Arab Emirates",
      "countryCode": "+971",
      "flagCode": "ae",
      "flagUrl": "https://flagcdn.com/24x18/ae.webp"
    },
    {
      "countryName": "Uruguay",
      "countryCode": "+598",
      "flagCode": "uy",
      "flagUrl": "https://flagcdn.com/24x18/uy.webp"
    },
    {
      "countryName": "US Virgin Islands",
      "countryCode": "+1",
      "flagCode": "vi",
      "flagUrl": "https://flagcdn.com/24x18/vi.webp"
    },
    {
      "countryName": "Uzbekistan",
      "countryCode": "+998",
      "flagCode": "uz",
      "flagUrl": "https://flagcdn.com/24x18/uz.webp"
    },
    {
      "countryName": "Vanuatu",
      "countryCode": "+678",
      "flagCode": "vu",
      "flagUrl": "https://flagcdn.com/24x18/vu.webp"
    },
    {
      "countryName": "Vatican City",
      "countryCode": "+39",
      "flagCode": "va",
      "flagUrl": "https://flagcdn.com/24x18/va.webp"
    },
    {
      "countryName": "Venezuela",
      "countryCode": "+58",
      "flagCode": "ve",
      "flagUrl": "https://flagcdn.com/24x18/ve.webp"
    },
    {
      "countryName": "Vietnam",
      "countryCode": "+84",
      "flagCode": "vn",
      "flagUrl": "https://flagcdn.com/24x18/vn.webp"
    },
    {
      "countryName": "Wallis & Futuna",
      "countryCode": "+681",
      "flagCode": "wf",
      "flagUrl": "https://flagcdn.com/24x18/wf.webp"
    },
    {
      "countryName": "Western Sahara",
      "countryCode": "+212",
      "flagCode": "eh",
      "flagUrl": "https://flagcdn.com/24x18/eh.webp"
    },
    {
      "countryName": "Yemen",
      "countryCode": "+967",
      "flagCode": "ye",
      "flagUrl": "https://flagcdn.com/24x18/ye.webp"
    },
    {
      "countryName": "Zambia",
      "countryCode": "+260",
      "flagCode": "zm",
      "flagUrl": "https://flagcdn.com/24x18/zm.webp"
    },
    {
      "countryName": "Zimbabwe",
      "countryCode": "+263",
      "flagCode": "zw",
      "flagUrl": "https://flagcdn.com/24x18/zw.webp"
    },
    {
      "countryName": "Åland Islands",
      "countryCode": "+358",
      "flagCode": "ax",
      "flagUrl": "https://flagcdn.com/24x18/ax.webp"
    }
  ]
  